import { useMarkFarmAsComplete } from '@/api/carbon.api';
import MarkAsCompleteBase from '@/modules/MarkAsComplete/MarkAsCompleteBase';

type Props = {
  farmId: string | undefined;
  isComplete: boolean;
  setReportRefetching: (reportRefetching: boolean) => void;
};
const MarkFarmAsComplete = ({ farmId, isComplete, setReportRefetching }: Props) => {
  const markAsCompleteMutation = useMarkFarmAsComplete();

  return (
    <MarkAsCompleteBase
      entityId={farmId}
      entityType="farm"
      isComplete={isComplete}
      setReportRefetching={setReportRefetching}
      markAsCompleteMutation={markAsCompleteMutation}
    />
  );
};
export default MarkFarmAsComplete;
